import { Component, computed, inject, TemplateRef, viewChild } from '@angular/core';
import { AuthService } from '../../../core/services/auth/auth.service';
import { MAIN_MENU_CONFIG } from '../base/main-menu.config';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs';

@Component({
  standalone: false,
  template: '',
})
export class BaseMainMenuComponent {
  private readonly authService = inject(AuthService);
  private readonly matDialog = inject(MatDialog);

  protected readonly signOutTmpl = viewChild.required<TemplateRef<unknown>>('signOutTmpl');

  protected readonly menuItems = computed(() => {
    const isAdmin = this.authService.isAdmin();
    return MAIN_MENU_CONFIG.filter(item => {
      if (isAdmin && item.hideForAdmin) {
        return false;
      }
      if (!isAdmin && item.adminOnly) {
        return false;
      }
      return true;
    });
  });

  logout() {
    this.matDialog.open(this.signOutTmpl(), {
      panelClass: 'sign-out-dialog',
      backdropClass: 'sign-out-dialog-backdrop'
    })
      .afterClosed()
      .pipe(
        filter(Boolean)
      )
      .subscribe(() => this.authService.logOut());
  }
}
